'use client'
import {
  RoundedElement_default
} from "./chunk-A33G3ULA.mjs";
import {
  CollapsableTextSection_default,
  CollapsableText_default
} from "./chunk-SCAEXZYV.mjs";
import {
  IconItem_default,
  LineClamp_default,
  ListItem_default,
  Price_default,
  ThemeMenu_default,
  ThemePopover_default,
  Weather_default
} from "./chunk-RFVCAZY5.mjs";
import {
  ContentfulButton_default
} from "./chunk-2YBW2YZW.mjs";
import {
  DecoratedSection_default,
  Subtitle_default
} from "./chunk-BK6LVH5K.mjs";
import {
  ContentfulMedia_default,
  ThemeButton_default
} from "./chunk-XIZE6A22.mjs";
import {
  useFavorites
} from "./chunk-BB4H5TUC.mjs";
import {
  useItinerary
} from "./chunk-YBJOQHTL.mjs";
import {
  useCalendarQuery_default
} from "./chunk-PLJBED27.mjs";
import {
  useFilterQuery_default
} from "./chunk-7GAGCG6W.mjs";
import {
  removeDuplicateSlashes
} from "./chunk-GMNAQNNP.mjs";
import {
  useGetEventsList
} from "./chunk-I4GWSKHL.mjs";
import {
  useGetCategories
} from "./chunk-HKGNX5TB.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/components/events/NumberedCarousel.tsx
import { Carousel, Typography as Typography5 } from "@wbk/ui";

// src/components/section/Title.tsx
import { twMerge } from "tailwind-merge";
import { Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var SectionTitle = ({ section, className }) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      "data-centered": section.titlePosition === "center",
      className: twMerge(
        "gap-S container relative mx-0 space-y-2 ps-0 data-[centered=true]:text-center",
        className
      ),
      children: [
        section.title && /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-XXL", children: section.title }),
        section.subtitle && /* @__PURE__ */ jsx(Typography, { variant: "body-L", children: section.subtitle })
      ]
    }
  );
};
var Title_default = SectionTitle;

// src/components/events/card/Item.tsx
import { Link, useRouter as useRouter3, useTranslation as useTranslation2 } from "@wbk/config";
import { twMerge as twMerge4 } from "tailwind-merge";
import { Button } from "@wbk/ui";
import { Heart } from "@wbk/svg";

// src/components/events/card/Location.tsx
import { twMerge as twMerge2 } from "tailwind-merge";
import { Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx2 } from "react/jsx-runtime";
var EventItemLocation = ({ location, className }) => {
  const text = (location == null ? void 0 : location.city) || "";
  return /* @__PURE__ */ jsx2(Typography2, { className: twMerge2("line-clamp-1 min-h-4 text-sm", className), children: text });
};
var Location_default = EventItemLocation;

// src/components/events/card/Type.tsx
import { useMemo } from "react";
import { formatDate } from "@wbk/utils";
import { Typography as Typography3 } from "@wbk/ui";
import { useRouter } from "@wbk/config";
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var EventItemType = ({ className, event, showDate = true }) => {
  const { locale } = useRouter();
  const date = useMemo(() => {
    if (!event.schedule)
      return "";
    if (event.schedule.text) {
      return event.schedule.text;
    }
    if (!event.schedule.openDateTime)
      return "";
    const startDate = formatDate(event.schedule.openDateTime, locale, {
      month: "short",
      day: "2-digit",
      timeZone: void 0
    });
    if (!event.schedule.closeDateTime || event.schedule.openDateTime.split("T")[0] === event.schedule.closeDateTime.split("T")[0]) {
      return startDate;
    }
    const endDate = formatDate(event.schedule.closeDateTime, locale, {
      month: "short",
      day: "2-digit",
      timeZone: void 0
    });
    return `${startDate} - ${endDate}`;
  }, [event.schedule, locale]);
  return /* @__PURE__ */ jsxs2("div", { className: `gap-XXS ${className || ""}`, children: [
    (event == null ? void 0 : event.category) && /* @__PURE__ */ jsxs2(
      Typography3,
      {
        variant: "label-M",
        strong: true,
        className: "inline",
        style: { color: event.category.color },
        children: [
          event == null ? void 0 : event.category.title,
          " ",
          ` ${showDate && date ? " \xB7 " : ""}`
        ]
      }
    ),
    showDate && date && /* @__PURE__ */ jsx3(Typography3, { className: "inline", variant: "label-S", children: date })
  ] });
};
var Type_default = EventItemType;

// src/components/events/card/Date.tsx
import { useMemo as useMemo2 } from "react";
import { formatDate as formatDate2 } from "@wbk/utils";
import { twMerge as twMerge3 } from "tailwind-merge";
import { Typography as Typography4 } from "@wbk/ui";
import { useRouter as useRouter2, useTranslation } from "@wbk/config";
import { Fragment, jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var EventItemDate = ({ className, event, renderType = "full", dateType = "time" }) => {
  const { locale } = useRouter2();
  const { t } = useTranslation("calendar_event");
  const dateInfo = useMemo2(() => {
    if (!event.schedule)
      return {};
    if (event.schedule.text) {
      return { text: event.schedule.text };
    }
    if (!event.schedule.openDateTime)
      return {};
    const startDate = new Date(event.schedule.openDateTime);
    if (!event.schedule.closeDateTime || new Date(event.schedule.closeDateTime).setHours(0, 0, 0, 0) === new Date(event.schedule.openDateTime).setHours(0, 0, 0, 0)) {
      return { startDate };
    }
    const endDate = new Date(event.schedule.closeDateTime);
    return { startDate, endDate };
  }, [event.schedule]);
  if (!dateInfo.startDate && !dateInfo.text)
    return null;
  if (renderType === "mini") {
    return /* @__PURE__ */ jsx4(Typography4, { variant: "label-XXS", children: dateInfo.text ? dateInfo.text : dateInfo.startDate ? dateType === "time" ? formatDate2(dateInfo.startDate, locale, {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit"
    }) : formatDate2(dateInfo.startDate, locale, {
      day: "2-digit",
      month: "long",
      year: "numeric"
    }) : null });
  }
  return /* @__PURE__ */ jsxs3("div", { className: twMerge3("space-y-XXS", className), children: [
    dateInfo.startDate && /* @__PURE__ */ jsxs3("div", { children: [
      /* @__PURE__ */ jsx4(Typography4, { variant: "heading-S", color: "secondary", children: formatDate2(dateInfo.startDate, locale, {
        day: "2-digit"
      }) }),
      /* @__PURE__ */ jsx4(Typography4, { color: "secondary", children: formatDate2(dateInfo.startDate, locale, {
        month: "short"
      }) })
    ] }),
    dateInfo.endDate && dateInfo.startDate && /* @__PURE__ */ jsxs3(Fragment, { children: [
      /* @__PURE__ */ jsx4(Typography4, { variant: "body-S", color: "secondary", children: t("calendar_event:until") }),
      /* @__PURE__ */ jsxs3("div", { children: [
        /* @__PURE__ */ jsx4(Typography4, { variant: "heading-S", color: "secondary", children: formatDate2(dateInfo.endDate, locale, {
          day: "2-digit"
        }) }),
        /* @__PURE__ */ jsx4(Typography4, { color: "secondary", children: formatDate2(dateInfo.endDate, locale, {
          month: "short"
        }) })
      ] })
    ] })
  ] });
};
var Date_default = EventItemDate;

// src/components/events/card/Item.tsx
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var EventItem = ({
  event,
  className,
  roundedElementContainerClassName,
  svgItemClassName,
  roundedElementClassName
}) => {
  const { t } = useTranslation2(["calendar_event", "calendar_common"]);
  const { locale } = useRouter3();
  const { toggleFavorite, isFavorite } = useFavorites();
  const isFaved = isFavorite(event.slug);
  return /* @__PURE__ */ jsxs4(
    Button,
    {
      theme: "transparent",
      as: Link,
      "data-testid": `item_${event.slug}`,
      className: twMerge4(
        "group relative h-full max-h-96 w-full gap-0 p-0 md:max-h-[520px]",
        className
      ),
      href: `/${locale}/${event.category.slug}/${event.slug}`,
      children: [
        /* @__PURE__ */ jsx5(
          ContentfulMedia_default,
          {
            media: event.image11,
            width: 600,
            height: 600,
            fit: "thumb",
            placeholder: true,
            className: "rounded-L ltr:rounded-bl-XXL ltr:rounded-tr-XXL rtl:rounded-br-XXL rtl:rounded-tl-XXL aspect-[2/3] h-full w-full object-cover md:min-h-[520px]"
          }
        ),
        /* @__PURE__ */ jsx5("div", { className: "rounded-XL bg-primary/60 p-S md:p-M absolute top-4 backdrop-blur-xl ltr:left-4 rtl:right-4", children: /* @__PURE__ */ jsx5(Date_default, { event, className: "text-secondary" }) }),
        /* @__PURE__ */ jsx5(
          RoundedElement_default,
          {
            variants: ["left-bottom", "top-right", "top-left"],
            className: roundedElementClassName,
            containerClassName: twMerge4(
              "absolute top-0 ps-XS pb-XS ltr:right-0 rtl:left-0",
              roundedElementContainerClassName
            ),
            textClassName: svgItemClassName,
            children: /* @__PURE__ */ jsx5(
              Button,
              {
                shape: "text",
                onClick: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggleFavorite(event.slug, event.title);
                },
                "aria-label": isFaved ? t("calendar_common:favorites.remove") : t("calendar_common:favorites.add"),
                className: "hover:bg-body/10 rounded-full border p-3",
                children: isFaved ? /* @__PURE__ */ jsx5(Heart, { className: "stroke-body-light text-error aspect-square h-6 w-6 object-contain" }) : /* @__PURE__ */ jsx5(Heart, { className: "stroke-body-dark/70 aspect-square h-6 w-6 object-contain text-transparent" })
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs4("div", { className: "absolute bottom-0 flex w-full flex-col", children: [
          /* @__PURE__ */ jsx5(
            RoundedElement_default,
            {
              variants: ["bottom-left", "right-top"],
              className: twMerge4("bg-body-level-1", roundedElementClassName),
              containerClassName: twMerge4("w-fit pt-XS pe-XS static", roundedElementContainerClassName),
              textClassName: svgItemClassName,
              children: /* @__PURE__ */ jsx5("div", { className: "bg-secondary px-S py-XS rounded-L relative", children: /* @__PURE__ */ jsx5(Type_default, { showDate: false, event }) })
            }
          ),
          /* @__PURE__ */ jsxs4(
            RoundedElement_default,
            {
              variants: ["bottom-left", "right-top"],
              className: "bg-primary rounded-L ltr:rounded-tr-XXL rtl:rounded-tl-XXL",
              containerClassName: twMerge4(
                "w-5/6 pe-XS pt-XS relative",
                roundedElementContainerClassName
              ),
              textClassName: svgItemClassName,
              children: [
                /* @__PURE__ */ jsxs4("div", { className: "space-y-L rounded-L p-M text-start", children: [
                  /* @__PURE__ */ jsx5(Location_default, { location: event.location, className: "text-primary-contrast" }),
                  /* @__PURE__ */ jsx5(LineClamp_default, { variant: "heading-S", className: "text-primary-contrast line-clamp-2", children: event.title })
                ] }),
                /* @__PURE__ */ jsx5(
                  RoundedElement_default,
                  {
                    textClassName: svgItemClassName,
                    className: roundedElementClassName,
                    containerClassName: twMerge4(
                      "top-0 ps-XS pb-XS ltr:right-0 rtl:left-0",
                      roundedElementContainerClassName
                    ),
                    variants: ["left-bottom", "top-right"],
                    children: /* @__PURE__ */ jsx5("div", { className: "bg-secondary px-S rounded-L py-XXS", children: /* @__PURE__ */ jsx5(Price_default, { event }) })
                  }
                )
              ]
            }
          )
        ] })
      ]
    },
    event.id
  );
};
var Item_default = EventItem;

// src/components/events/NumberedCarousel.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var NumberedCarousel = ({ section, className }) => {
  const events = section.contentCollection.items;
  if (!(events == null ? void 0 : events.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs5(
    DecoratedSection_default,
    {
      section,
      "data-testid": `section_events_numbered_carousel_${section.id}`,
      className,
      children: [
        /* @__PURE__ */ jsx6(Title_default, { section }),
        /* @__PURE__ */ jsx6(
          Carousel,
          {
            options: { dragFree: true },
            className: "py-1",
            arrowsClassName: "hidden 2xl:block container",
            arrows: "middle",
            children: events.map((event, i) => /* @__PURE__ */ jsxs5(
              "div",
              {
                className: "relative flex shrink-0 basis-[360px] sm:basis-[440px] ltr:mr-6 rtl:ml-6",
                children: [
                  /* @__PURE__ */ jsx6(Item_default, { event }),
                  /* @__PURE__ */ jsx6(
                    Typography5,
                    {
                      variant: "display-L",
                      className: "text-secondary-700 w-28 shrink-0 self-center whitespace-nowrap text-nowrap !text-[250px] sm:w-32 ltr:-ml-12 ltr:sm:-ml-10 rtl:-mr-12 rtl:sm:-mr-10",
                      children: i + 1
                    }
                  )
                ]
              },
              i
            ))
          }
        )
      ]
    }
  );
};
var NumberedCarousel_default = NumberedCarousel;

// src/components/events/EventCarousel.tsx
import { useMemo as useMemo3, useState } from "react";
import { Carousel as Carousel3 } from "@wbk/ui";

// src/components/section/TitleWithCategories.tsx
import { twMerge as twMerge5 } from "tailwind-merge";
import { Carousel as Carousel2 } from "@wbk/ui";

// src/components/filters/categories/Link.tsx
import { Divider, Spinner, Typography as Typography6 } from "@wbk/ui";
import { CloseIcon } from "@wbk/svg";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var CategoryLink = ({ item, onClick, selected, total, totalLoading }) => {
  return /* @__PURE__ */ jsxs6(
    ThemeButton_default,
    {
      theme: "secondary",
      className: "aria-pressed:border-tertiary bg-category shadow-category aria-[pressed=false]:border-category group flex shrink-0 items-center border-2 border-transparent pb-1.5 transition-all",
      "aria-pressed": selected,
      onClick,
      children: [
        /* @__PURE__ */ jsxs6("div", { className: "flex items-start gap-1", children: [
          item.icon && /* @__PURE__ */ jsx7(
            ContentfulMedia_default,
            {
              media: item.icon,
              width: 80,
              height: 80,
              className: "mt-1 h-5 w-5",
              format: null
            }
          ),
          /* @__PURE__ */ jsxs6("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ jsxs6("div", { children: [
              /* @__PURE__ */ jsx7(Typography6, { variant: "label-L", children: item.title }),
              /* @__PURE__ */ jsx7(
                Divider,
                {
                  className: `max-w-[40%] border ${selected ? "border-tertiary" : "border-transparent"}`
                }
              )
            ] }),
            totalLoading ? /* @__PURE__ */ jsx7(Spinner, { className: "h-3 w-3" }) : total ? /* @__PURE__ */ jsx7(Typography6, { variant: "label-S", children: `(${total})` }) : null
          ] })
        ] }),
        selected && /* @__PURE__ */ jsx7(CloseIcon, { className: "h-3 w-3 shrink-0" })
      ]
    }
  );
};
var Link_default = CategoryLink;

// src/components/section/TitleWithCategories.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var TitleWithCategories = ({ section, categories, selected, onSelect, className }) => {
  return /* @__PURE__ */ jsxs7("div", { className: twMerge5("gap-S container mx-0 flex items-end justify-between ps-0", className), children: [
    /* @__PURE__ */ jsxs7("div", { className: "space-y-L flex-1 grow overflow-hidden", children: [
      /* @__PURE__ */ jsx8(Title_default, { section: { title: section.title } }),
      categories.length > 1 && /* @__PURE__ */ jsx8(Carousel2, { as: "ul", containerClassName: "flex gap-2", className: "py-px", children: categories.map((category) => {
        const active = selected === category.slug;
        return /* @__PURE__ */ jsx8("li", { className: "shrink-0", children: /* @__PURE__ */ jsx8(
          Link_default,
          {
            item: category,
            selected: active,
            onClick: () => onSelect(active ? void 0 : category.slug)
          }
        ) }, category.id);
      }) })
    ] }),
    /* @__PURE__ */ jsx8(Subtitle_default, { section, className: "pb-XXS hidden max-w-xs text-end md:block" })
  ] });
};
var TitleWithCategories_default = TitleWithCategories;

// src/components/events/EventCarousel.tsx
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var EventsCarousel = ({ section, className }) => {
  const events = section.contentCollection.items;
  const [category, setCategory] = useState();
  const items = useMemo3(() => {
    const seenCategories = /* @__PURE__ */ new Set();
    const categories = [];
    const filtered = [];
    for (const event of events) {
      if (!seenCategories.has(event == null ? void 0 : event.category.slug)) {
        seenCategories.add(event == null ? void 0 : event.category.slug);
        categories.push(event.category);
      }
      if (!category || event.category.slug === category) {
        filtered.push(event);
      }
    }
    return { categories, events: filtered };
  }, [events, category]);
  if (!(events == null ? void 0 : events.length)) {
    return null;
  }
  return /* @__PURE__ */ jsxs8(
    DecoratedSection_default,
    {
      section,
      className,
      "data-testid": `section_events_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsx9(
          TitleWithCategories_default,
          {
            section,
            categories: items.categories,
            selected: category,
            onSelect: setCategory
          }
        ),
        /* @__PURE__ */ jsx9(
          Carousel3,
          {
            className: "p-0.5",
            arrows: "middle",
            options: { dragFree: true },
            arrowsClassName: "hidden 2xl:block",
            children: items.events.map((event) => /* @__PURE__ */ jsx9(
              "div",
              {
                className: "relative shrink-0 basis-80 md:basis-[456px] ltr:mr-4 rtl:ml-4",
                children: /* @__PURE__ */ jsx9(Item_default, { event })
              },
              event.id
            ))
          }
        )
      ]
    }
  );
};
var EventCarousel_default = EventsCarousel;

// src/components/cards/Icons.tsx
import { Fragment as Fragment2 } from "react";
import { Carousel as Carousel4, Divider as Divider2 } from "@wbk/ui";
import { Fragment as Fragment3, jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var CardIcons = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsxs9(Fragment3, { children: [
    cards.length <= 5 && /* @__PURE__ */ jsx10(
      DecoratedSection_default,
      {
        section,
        className: "hidden lg:block",
        "data-testid": `section_cards_icons_${section.id}`,
        children: /* @__PURE__ */ jsx10("ul", { className: "flex p-0.5", children: cards.map((card, i) => {
          return /* @__PURE__ */ jsxs9(Fragment2, { children: [
            /* @__PURE__ */ jsx10("li", { className: "h-full w-full", children: /* @__PURE__ */ jsx10(IconItem_default, { card, className: "block disabled:bg-transparent" }) }),
            i < cards.length - 1 && /* @__PURE__ */ jsx10("li", { className: "m-auto h-4/6", children: /* @__PURE__ */ jsx10(Divider2, { className: "bg-paper h-full w-px" }) })
          ] }, card.id);
        }) })
      }
    ),
    /* @__PURE__ */ jsx10(
      DecoratedSection_default,
      {
        section,
        groupClassName: "data-[with-grid=true]:lg:hidden ",
        "data-with-grid": cards.length <= 5,
        "data-testid": `section_cards_icons_${section.id}`,
        children: /* @__PURE__ */ jsx10(
          Carousel4,
          {
            as: "ul",
            rootClassName: "w-full overflow-hidden",
            arrowsClassName: "[&>button]:!bg-transparent",
            className: "p-1",
            options: { dragFree: true },
            arrows: "middle",
            children: cards.map((card, i) => {
              return /* @__PURE__ */ jsxs9(Fragment2, { children: [
                /* @__PURE__ */ jsx10("li", { className: "h-full shrink-0 basis-1/3 sm:basis-64 md:basis-80", children: /* @__PURE__ */ jsx10(IconItem_default, { card }) }),
                i < cards.length - 1 && /* @__PURE__ */ jsx10("li", { className: "m-auto h-4/6", children: /* @__PURE__ */ jsx10(Divider2, { className: "bg-paper h-full w-px" }) })
              ] }, card.id);
            })
          }
        )
      }
    )
  ] });
};
var Icons_default = CardIcons;

// src/components/cards/Carousel.tsx
import { Button as Button2, Carousel as Carousel5, Typography as Typography7 } from "@wbk/ui";
import { Link as Link2 } from "@wbk/config";
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var CardsCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsxs10(DecoratedSection_default, { section, "data-testid": `section_cards_carousel_${section.id}`, children: [
    /* @__PURE__ */ jsx11(Title_default, { section }),
    /* @__PURE__ */ jsx11(
      Carousel5,
      {
        options: { dragFree: true },
        className: "p-0.5",
        arrowsClassName: "container hidden 2xl:block",
        arrows: "middle",
        children: cards.map((card) => {
          var _a, _b;
          return /* @__PURE__ */ jsxs10(
            Button2,
            {
              theme: "black",
              as: ((_a = card.button) == null ? void 0 : _a.href) ? Link2 : "div",
              className: "rounded-L relative flex shrink-0 basis-[200px] flex-col gap-0 p-0 text-start ltr:mr-6 rtl:ml-6",
              href: (_b = card.button) == null ? void 0 : _b.href,
              "data-testid": `card_item_${card.id}`,
              children: [
                card.background && /* @__PURE__ */ jsx11(
                  ContentfulMedia_default,
                  {
                    className: "aspect-[2/3] object-cover",
                    media: card.background,
                    ratio: "3x1",
                    fit: "thumb",
                    placeholder: true
                  }
                ),
                /* @__PURE__ */ jsx11(Typography7, { variant: "heading-S", className: "w-full p-4", children: card.title })
              ]
            },
            card.id
          );
        })
      }
    )
  ] });
};
var Carousel_default = CardsCarousel;

// src/components/events/ScheduleCarousel.tsx
import { useState as useState2 } from "react";
import { useRouter as useRouter4, useTranslation as useTranslation3 } from "@wbk/config";
import { Button as Button3, Carousel as Carousel6, Typography as Typography8 } from "@wbk/ui";
import { ChevronIcon, SearchIcon } from "@wbk/svg";

// src/components/ui/Loading/CategoryLoading.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var CategoryLoading = () => {
  return /* @__PURE__ */ jsx12("div", { className: "flex overflow-hidden", children: Array.from({ length: 5 }).map((_, index) => /* @__PURE__ */ jsx12(
    "div",
    {
      className: "bg-body-level-2 h-12 w-36 shrink-0 animate-pulse rounded-md ltr:mr-4 rtl:ml-4"
    },
    index
  )) });
};
var CategoryLoading_default = CategoryLoading;

// src/components/ui/Loading/EventLoading.tsx
import { twMerge as twMerge6 } from "tailwind-merge";
import { ImageWithPlaceholder } from "@wbk/ui";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var EventLoading = ({ type = "grid", count = 12, className, mini = false }) => {
  return /* @__PURE__ */ jsx13(
    "div",
    {
      className: twMerge6(
        type === "grid" ? "grid grid-cols-1 gap-4 sm:grid-cols-3" : mini ? "flex [&>div]:me-4 [&>div]:shrink-0 [&>div]:basis-72 [&>div]:sm:basis-80" : "flex [&>div]:me-4 [&>div]:shrink-0 [&>div]:basis-80 [&>div]:sm:basis-[456px]",
        "shrink-0",
        className
      ),
      children: [...Array(count)].map((_, index) => {
        return /* @__PURE__ */ jsxs11("div", { className: "bg-body-level-2 rounded-S overflow-hidden", children: [
          /* @__PURE__ */ jsx13(ImageWithPlaceholder, { className: "aspect-1 animate-pulse" }),
          /* @__PURE__ */ jsxs11("div", { className: "p-M space-y-2", children: [
            /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 h-4 w-1/2 animate-pulse" }),
            /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 h-4 w-3/4 animate-pulse" }),
            /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 h-4 w-1/2 animate-pulse" }),
            /* @__PURE__ */ jsx13("div", { className: "bg-body-level-1 h-4 w-3/4 animate-pulse" })
          ] })
        ] }, index);
      })
    }
  );
};
var EventLoading_default = EventLoading;

// src/components/events/ScheduleCarousel.tsx
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var TYPES = ["day", "thisweek", "thismonth"];
var EventsScheduleCarousel = ({ section, className }) => {
  const { t } = useTranslation3("calendar_common");
  const { locale } = useRouter4();
  const [filter, setFilter] = useState2("day");
  const [category, setCategory] = useState2();
  const { query } = useFilterQuery_default({
    state: { category: category == null ? void 0 : category.slug, date: filter === "day" ? "today" : filter }
  });
  const { data, isLoading } = useGetEventsList({
    lang: locale,
    limit: 20,
    where: query.where
  });
  return /* @__PURE__ */ jsxs12(
    DecoratedSection_default,
    {
      section,
      className,
      "data-testid": `section_events_schedule_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs12("div", { className: "relative space-y-2", children: [
          section.title && /* @__PURE__ */ jsxs12("div", { className: "inline-flex items-center gap-1", children: [
            /* @__PURE__ */ jsx14(Typography8, { as: "h2", variant: "heading-XXL", className: "inline", children: section.title }),
            /* @__PURE__ */ jsx14(
              ThemeMenu_default,
              {
                className: "inline-flex",
                render: ({ open }) => /* @__PURE__ */ jsxs12(Button3, { shape: "text", className: "p-0", onClick: open, children: [
                  /* @__PURE__ */ jsx14(Typography8, { as: "span", variant: "heading-XXL", color: "tertiary", className: "px-1", children: t(`calendar_common:date.${filter}`) }),
                  /* @__PURE__ */ jsx14("div", { className: "border-primary rounded-full border p-2", children: /* @__PURE__ */ jsx14(ChevronIcon, { className: "h-3 w-3 shrink-0 rotate-90" }) })
                ] }),
                trigger: { theme: "primary" },
                item: { theme: "primary" },
                value: filter,
                options: TYPES.map((type) => ({
                  value: type,
                  text: /* @__PURE__ */ jsx14(Typography8, { variant: "heading-XS", children: t(`calendar_common:date.${type}`) })
                })),
                onChange: (e) => setFilter(e.value)
              }
            )
          ] }),
          section.subtitle && /* @__PURE__ */ jsx14(Typography8, { variant: "body-L", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx14(Categories, { category, setCategory }),
        isLoading ? /* @__PURE__ */ jsx14(EventLoading_default, { count: 4, type: "carousel" }) : data && !!(data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsx14(
          Carousel6,
          {
            className: "p-0.5",
            arrowsClassName: "hidden 2xl:block container",
            arrows: "middle",
            options: { dragFree: true },
            children: data.items.map((event, i) => /* @__PURE__ */ jsx14("div", { className: "relative shrink-0 basis-80 md:basis-[456px] ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx14(Item_default, { event }) }, i))
          }
        ) : /* @__PURE__ */ jsxs12("div", { className: "flex h-[400px] flex-col items-center justify-center space-y-6 py-4 text-center", children: [
          /* @__PURE__ */ jsx14("div", { className: "bg-body-level-2 mx-auto flex h-24 w-24 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx14(SearchIcon, { className: "h-14 w-14 shrink-0" }) }),
          /* @__PURE__ */ jsx14("div", { className: "space-y-2", children: /* @__PURE__ */ jsx14(Typography8, { variant: "heading-L", as: "h4", children: t("calendar_common:empty_events") }) })
        ] })
      ]
    }
  );
};
var Categories = ({ category, setCategory }) => {
  const { locale } = useRouter4();
  const { data: categories, isLoading: isCategoriesLoading } = useGetCategories({
    lang: locale,
    where: { parent_exists: false },
    limit: 20
  });
  return /* @__PURE__ */ jsx14("div", { className: "space-y-2", children: isCategoriesLoading ? /* @__PURE__ */ jsx14(CategoryLoading_default, {}) : categories && !!categories.length ? /* @__PURE__ */ jsx14(Carousel6, { as: "ul", containerClassName: "flex gap-2", className: "py-px", children: categories.map((item) => {
    const active = (category == null ? void 0 : category.slug) === item.slug;
    return /* @__PURE__ */ jsx14("li", { className: "shrink-0", children: /* @__PURE__ */ jsx14(
      Link_default,
      {
        item,
        selected: active,
        onClick: () => setCategory(active ? void 0 : item)
      }
    ) }, item.id);
  }) }) : null });
};
var ScheduleCarousel_default = EventsScheduleCarousel;

// src/components/category/Carousel.tsx
import { Link as Link3, useRouter as useRouter5 } from "@wbk/config";
import { Button as Button4, Carousel as Carousel7, Typography as Typography9 } from "@wbk/ui";
import { twMerge as twMerge7 } from "tailwind-merge";
import { jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var CategoryCarousel = ({ section, className }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter5();
  return /* @__PURE__ */ jsxs13(
    DecoratedSection_default,
    {
      section,
      className: twMerge7("flex flex-col gap-2 md:flex-row md:items-center", className),
      "data-testid": `section_category_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs13("div", { className: "container mx-0 text-balance p-0 md:max-w-[280px]", children: [
          section.title && /* @__PURE__ */ jsx15(Typography9, { as: "h2", variant: "heading-XXL", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx15(Typography9, { variant: "heading-L", className: "my-2", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx15(
          Carousel7,
          {
            rootClassName: "w-full overflow-hidden",
            options: { dragFree: true },
            className: "p-0.5",
            arrowsClassName: "container hidden 2xl:block",
            arrows: "middle",
            children: items.map((item) => /* @__PURE__ */ jsx15(
              Button4,
              {
                as: Link3,
                to: `/${locale}/${item.slug}`,
                className: "group relative flex shrink-0 basis-80 flex-col items-center justify-center gap-2 p-0 sm:basis-96 ltr:mr-4 rtl:ml-4",
                theme: "white",
                shape: "text",
                "data-bg": !!item.background,
                children: /* @__PURE__ */ jsxs13("div", { className: "rounded-S bg-body border-paper relative aspect-[3/2] w-full overflow-hidden border", children: [
                  item.background && /* @__PURE__ */ jsx15(
                    ContentfulMedia_default,
                    {
                      className: "h-full w-full object-cover",
                      media: item.background,
                      placeholder: true
                    }
                  ),
                  /* @__PURE__ */ jsxs13(
                    "div",
                    {
                      className: twMerge7(
                        "absolute inset-0 left-0 top-0 flex flex-col items-center justify-center gap-1 transition-all",
                        item.background ? "text-body-light bg-body-dark/40 hover:bg-body-dark/20" : "text-body-dark hover:opacity-70"
                      ),
                      children: [
                        item.icon && /* @__PURE__ */ jsx15(
                          ContentfulMedia_default,
                          {
                            media: item.icon,
                            width: 50,
                            height: 50,
                            className: "aspect-1 object-contain group-data-[bg=true]:invert"
                          }
                        ),
                        /* @__PURE__ */ jsx15(Typography9, { variant: "heading-S", children: item.title })
                      ]
                    }
                  )
                ] })
              },
              item.id
            ))
          }
        )
      ]
    }
  );
};
var Carousel_default2 = CategoryCarousel;

// src/components/cards/Rectangular.tsx
import { Carousel as Carousel8 } from "@wbk/ui";

// src/components/cards/Item.tsx
import { twMerge as twMerge8 } from "tailwind-merge";
import { Button as Button5, Typography as Typography10 } from "@wbk/ui";
import { Link as Link4, useRouter as useRouter6 } from "@wbk/config";
import { jsx as jsx16, jsxs as jsxs14 } from "react/jsx-runtime";
var CardItem = ({ card, className }) => {
  var _a, _b, _c, _d, _e;
  const { locale } = useRouter6();
  const isExternal = (_b = (_a = card.button) == null ? void 0 : _a.href) == null ? void 0 : _b.startsWith("http");
  return /* @__PURE__ */ jsxs14(
    Button5,
    {
      theme: "transparent",
      as: ((_c = card.button) == null ? void 0 : _c.href) ? Link4 : "div",
      className: twMerge8(
        "rounded-L group relative w-full justify-start gap-0 bg-transparent p-0 text-start",
        className
      ),
      href: isExternal ? (_d = card.button) == null ? void 0 : _d.href : removeDuplicateSlashes(`/${locale}/${(_e = card.button) == null ? void 0 : _e.href}`),
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener noreferrer" : void 0,
      "data-testid": `card_item_${card.id}`,
      children: [
        card.background && /* @__PURE__ */ jsx16(
          ContentfulMedia_default,
          {
            className: "aspect-1 absolute h-full object-cover",
            media: card.background,
            ratio: "3x1",
            fit: "thumb",
            placeholder: true
          }
        ),
        /* @__PURE__ */ jsxs14("div", { className: "relative z-10 w-full space-y-10 p-6", children: [
          /* @__PURE__ */ jsxs14("div", { className: "space-y-1", children: [
            /* @__PURE__ */ jsxs14("div", { className: "flex items-center justify-between gap-2", children: [
              /* @__PURE__ */ jsx16(
                Typography10,
                {
                  variant: "heading-L",
                  className: "font-label text-body-light sm:text-heading-XXL",
                  children: card.title
                }
              ),
              /* @__PURE__ */ jsx16(Typography10, { variant: "heading-S", className: "font-label text-body-light", children: card.subtitle })
            ] }),
            card.description && /* @__PURE__ */ jsx16(CollapsableText_default, { className: "text-body-light", markdown: true, children: card.description })
          ] }),
          card.button && /* @__PURE__ */ jsx16(ContentfulButton_default, { as: "div", className: "w-fit", button: card.button, tabIndex: -1 })
        ] })
      ]
    },
    card.id
  );
};
var Item_default2 = CardItem;

// src/components/cards/Rectangular.tsx
import { jsx as jsx17, jsxs as jsxs15 } from "react/jsx-runtime";
var RectangularCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsxs15(DecoratedSection_default, { section, "data-testid": `section_rectangular_carousel_${section.id}`, children: [
    /* @__PURE__ */ jsx17(Title_default, { section }),
    /* @__PURE__ */ jsx17(
      Carousel8,
      {
        options: { dragFree: true },
        className: "p-0.5",
        arrowsClassName: "container hidden 2xl:block",
        arrows: "middle",
        children: cards.map((card, i) => /* @__PURE__ */ jsx17(
          Item_default2,
          {
            card,
            className: "relative flex shrink-0 basis-72 sm:basis-[472px] ltr:mr-6 rtl:ml-6"
          },
          i
        ))
      }
    )
  ] });
};
var Rectangular_default = RectangularCarousel;

// src/components/category/RoundedCarousel.tsx
import { Button as Button6, Carousel as Carousel9, Typography as Typography11 } from "@wbk/ui";
import { twMerge as twMerge9 } from "tailwind-merge";
import { Link as Link5, useRouter as useRouter7 } from "@wbk/config";
import { ArrowIcon } from "@wbk/svg";
import { jsx as jsx18, jsxs as jsxs16 } from "react/jsx-runtime";
var CategoryCarousel2 = ({ section, className }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter7();
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ jsxs16(
    DecoratedSection_default,
    {
      section,
      className: twMerge9("flex flex-col gap-10 md:flex-row md:items-center", className),
      "data-testid": `section_category_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsx18(Title_default, { section, className: "text-balance md:max-w-[240px]" }),
        /* @__PURE__ */ jsx18(
          Carousel9,
          {
            as: "ul",
            rootClassName: "w-full overflow-hidden",
            className: "p-1",
            arrows: "middle",
            options: { dragFree: true },
            arrowsClassName: "hidden 2xl:block container",
            children: items.map((item, i) => /* @__PURE__ */ jsx18(
              "li",
              {
                className: "relative aspect-[2/3] max-h-44 shrink-0 basis-52 sm:max-h-56 md:basis-56 ltr:mr-8 rtl:ml-8",
                children: /* @__PURE__ */ jsxs16(
                  Button6,
                  {
                    as: Link5,
                    href: `/${locale}/${item.slug}`,
                    className: "rounded-XL h-full w-full",
                    theme: "secondary",
                    children: [
                      /* @__PURE__ */ jsx18(
                        RoundedElement_default,
                        {
                          variants: ["left-bottom", "top-right"],
                          containerClassName: "absolute top-0 ps-XS pb-XS  ltr:-right-0 rtl:-left-0",
                          children: /* @__PURE__ */ jsx18(Button6, { as: "div", className: "h-8 w-8 rounded-full border sm:h-12 sm:w-12", children: /* @__PURE__ */ jsx18(ArrowIcon, { className: "h-4 w-4 shrink-0 object-contain sm:h-6 sm:w-6 ltr:-rotate-45 ltr:-scale-x-100 rtl:rotate-45" }) })
                        }
                      ),
                      /* @__PURE__ */ jsx18(
                        ContentfulMedia_default,
                        {
                          width: 48,
                          height: 48,
                          className: "h-8 w-8 shrink-0 sm:h-12 sm:w-12",
                          media: item.icon
                        }
                      ),
                      /* @__PURE__ */ jsx18(
                        RoundedElement_default,
                        {
                          variants: ["bottom-left", "right-top"],
                          containerClassName: "absolute bottom-0 pe-XS pt-XS rtl:right-0 ltr:left-0 max-w-44 md:max-w-48",
                          children: /* @__PURE__ */ jsx18(Button6, { as: "div", theme: "secondary", className: "rounded-XL text-start", children: /* @__PURE__ */ jsx18(Typography11, { className: "line-clamp-1", strong: true, children: item.title }) })
                        }
                      )
                    ]
                  }
                )
              },
              item.id + i
            ))
          }
        )
      ]
    }
  );
};
var RoundedCarousel_default = CategoryCarousel2;

// src/components/cards/RoundedIcons.tsx
import { Carousel as Carousel10 } from "@wbk/ui";
import { jsx as jsx19 } from "react/jsx-runtime";
var CardRoundedIcons = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsx19(DecoratedSection_default, { section, "data-testid": `section_cards_rounded_icons_${section.id}`, children: /* @__PURE__ */ jsx19(
    Carousel10,
    {
      as: "ul",
      options: { dragFree: true },
      arrowsClassName: "hidden 2xl:block",
      arrows: "middle",
      children: cards.map((card) => /* @__PURE__ */ jsx19("li", { className: "flex shrink-0 basis-72 p-1 ps-2.5 first:ps-1 sm:basis-80", children: /* @__PURE__ */ jsx19(IconItem_default, { className: "block w-full py-6 text-start", card }) }, card.id))
    }
  ) });
};
var RoundedIcons_default = CardRoundedIcons;

// src/components/cards/Square.tsx
import { Carousel as Carousel11 } from "@wbk/ui";

// src/components/cards/SquareItem.tsx
import { twMerge as twMerge10 } from "tailwind-merge";
import { Button as Button7, Typography as Typography12 } from "@wbk/ui";
import { Link as Link6, useRouter as useRouter8 } from "@wbk/config";
import { jsx as jsx20, jsxs as jsxs17 } from "react/jsx-runtime";
var SquareItem = ({ card, className }) => {
  var _a, _b, _c, _d, _e;
  const { locale } = useRouter8();
  const isExternal = (_b = (_a = card.button) == null ? void 0 : _a.href) == null ? void 0 : _b.startsWith("http");
  return /* @__PURE__ */ jsxs17(
    Button7,
    {
      theme: "transparent",
      as: ((_c = card.button) == null ? void 0 : _c.href) ? Link6 : "div",
      className: twMerge10(
        "rounded-L bg-body-level-1 group relative min-h-96 w-full justify-start gap-0 p-0 text-start",
        className
      ),
      href: isExternal ? (_d = card.button) == null ? void 0 : _d.href : removeDuplicateSlashes(`/${locale}/${(_e = card.button) == null ? void 0 : _e.href}`),
      target: isExternal ? "_blank" : void 0,
      rel: isExternal ? "noopener noreferrer" : void 0,
      "data-testid": `card_item_${card.id}`,
      children: [
        card.background && /* @__PURE__ */ jsx20(
          ContentfulMedia_default,
          {
            className: "rounded-XL ltr:rounded-br-XXL ltr:rounded-tl-XXL rtl:rounded-bl-XXL rtl:rounded-tr-XXL absolute h-full object-cover",
            media: card.background,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          }
        ),
        /* @__PURE__ */ jsx20(
          RoundedElement_default,
          {
            variants: ["top-left", "right-bottom"],
            containerClassName: "top-0 pe-XS pb-XS ltr:left-0 rtl:right-0",
            children: /* @__PURE__ */ jsx20(Typography12, { variant: "heading-L", className: "p-XXS", children: card.title })
          }
        ),
        card.button && /* @__PURE__ */ jsx20(
          RoundedElement_default,
          {
            variants: ["bottom-right", "left-top"],
            containerClassName: "bottom-0 ps-XS pt-XS ltr:right-0 rtl:left-0",
            children: /* @__PURE__ */ jsx20(ContentfulButton_default, { as: "div", className: "w-fit", button: card.button, tabIndex: -1 })
          }
        ),
        card.subtitle && /* @__PURE__ */ jsx20("div", { className: "absolute top-0 z-10 flex p-4 ltr:right-0 rtl:left-0", children: /* @__PURE__ */ jsxs17("div", { className: "rounded-M bg-body/5 gap-L flex items-center justify-between px-4 py-2 backdrop-blur-xl", children: [
          /* @__PURE__ */ jsxs17("div", { className: "space-y-XXS", children: [
            /* @__PURE__ */ jsx20(Typography12, { variant: "heading-S", className: "text-body-light", children: card.subtitle }),
            card.subtitleLine2 && /* @__PURE__ */ jsx20(Typography12, { className: "text-body-light", variant: "body-S", children: card.subtitleLine2 })
          ] }),
          card.icon && /* @__PURE__ */ jsx20(ContentfulMedia_default, { className: "shrink-0", media: card.icon })
        ] }) })
      ]
    },
    card.id
  );
};
var SquareItem_default = SquareItem;

// src/components/cards/Square.tsx
import { jsx as jsx21, jsxs as jsxs18 } from "react/jsx-runtime";
var SquareCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length))
    return null;
  return /* @__PURE__ */ jsxs18(DecoratedSection_default, { section, "data-testid": `section_square_carousel_${section.id}`, children: [
    /* @__PURE__ */ jsx21(Title_default, { section }),
    /* @__PURE__ */ jsx21(
      Carousel11,
      {
        options: { dragFree: true },
        className: "p-0.5",
        arrowsClassName: "hidden 2xl:block",
        arrows: "middle",
        children: cards.map((card, i) => /* @__PURE__ */ jsx21(
          SquareItem_default,
          {
            card,
            className: "relative flex shrink-0 basis-72 sm:basis-[472px] ltr:mr-6 rtl:ml-6"
          },
          i
        ))
      }
    )
  ] });
};
var Square_default = SquareCarousel;

// src/components/events/CategoryCarousel.tsx
import { useMemo as useMemo4, useState as useState3 } from "react";
import { useRouter as useRouter9, useTranslation as useTranslation4 } from "@wbk/config";
import { Carousel as Carousel12, Typography as Typography13 } from "@wbk/ui";
import { SearchIcon as SearchIcon2 } from "@wbk/svg";
import { jsx as jsx22, jsxs as jsxs19 } from "react/jsx-runtime";
var EventsPerCategoryCarousel = ({ section, className }) => {
  var _a;
  const { locale } = useRouter9();
  const { t } = useTranslation4("calendar_common");
  const [selected, setSelected] = useState3();
  const categories = useMemo4(() => {
    const list = [];
    const slugs = [];
    const items = section.contentCollection.items || [];
    for (const category of items) {
      if (category.__typename === "Category") {
        list.push(category);
        slugs.push(category.slug);
      }
    }
    return { list, slugs };
  }, [section.contentCollection.items]);
  const { data: events, isLoading } = useGetEventsList({
    lang: locale,
    limit: 50,
    where: {
      OR: [
        { category: { slug_in: selected ? [selected] : categories.slugs } },
        { subCategory: { slug_in: selected ? [selected] : categories.slugs } }
      ]
    }
  });
  return /* @__PURE__ */ jsxs19(
    DecoratedSection_default,
    {
      section,
      className,
      "data-testid": `section_events_category_carousel_${section.id}`,
      children: [
        /* @__PURE__ */ jsx22(
          TitleWithCategories_default,
          {
            section,
            categories: categories.list,
            selected,
            onSelect: setSelected
          }
        ),
        isLoading ? /* @__PURE__ */ jsx22(EventLoading_default, { count: 4, type: "carousel" }) : ((_a = events == null ? void 0 : events.items) == null ? void 0 : _a.length) ? /* @__PURE__ */ jsx22(
          Carousel12,
          {
            className: "p-0.5",
            arrows: "middle",
            options: { dragFree: true },
            arrowsClassName: "hidden 2xl:block",
            children: events.items.map((event) => /* @__PURE__ */ jsx22(
              "div",
              {
                className: "relative shrink-0 basis-80 md:basis-[456px] ltr:mr-4 rtl:ml-4",
                children: /* @__PURE__ */ jsx22(Item_default, { event })
              },
              event.id
            ))
          }
        ) : /* @__PURE__ */ jsxs19("div", { className: "flex h-[400px] flex-col items-center justify-center space-y-6 py-4 text-center", children: [
          /* @__PURE__ */ jsx22("div", { className: "bg-body-level-2 mx-auto flex h-24 w-24 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx22(SearchIcon2, { className: "h-14 w-14 shrink-0" }) }),
          /* @__PURE__ */ jsx22("div", { className: "space-y-2", children: /* @__PURE__ */ jsx22(Typography13, { variant: "heading-L", as: "h4", children: t("calendar_common:empty_events") }) })
        ] })
      ]
    }
  );
};
var CategoryCarousel_default = EventsPerCategoryCarousel;

// src/components/calendar/CalendarSection.tsx
import { formatDate as formatDate5 } from "@wbk/utils";
import { useRouter as useRouter15, useTranslation as useTranslation8 } from "@wbk/config";
import { Button as Button10, Typography as Typography17 } from "@wbk/ui";
import { ChevronIcon as ChevronIcon2 } from "@wbk/svg";

// src/components/calendar/monthly/index.tsx
import { useMemo as useMemo7 } from "react";
import { breakdownDurationToUnits, dateAdd, splitDateTime as splitDateTime3, startOfDay as startOfDay2 } from "@wbk/utils";
import { useRouter as useRouter14 } from "@wbk/config";

// src/components/calendar/monthly/Grid.tsx
import { useRouter as useRouter12 } from "@wbk/config";
import { DayPicker, Typography as Typography15 } from "@wbk/ui";
import { splitDateTime } from "@wbk/utils";
import { WaveIcon } from "@wbk/svg";
import { twMerge as twMerge11 } from "tailwind-merge";

// src/components/ui/Loading/MonthlyPlaceholder.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var MonthlyPlaceholder = () => {
  return /* @__PURE__ */ jsx23("div", { className: "py-8 md:container", children: /* @__PURE__ */ jsx23("div", { className: "grid animate-pulse grid-cols-7 gap-1 py-5", children: Array.from({ length: 35 }, (_, i) => {
    return /* @__PURE__ */ jsx23(
      "div",
      {
        className: "bg-body-level-2 rounded-L h-20 border p-1 md:min-h-64 md:p-2"
      },
      i
    );
  }) }) });
};
var MonthlyPlaceholder_default = MonthlyPlaceholder;

// src/components/calendar/monthly/DayCalendarEvents.tsx
import { ResponsiveModal } from "@wbk/ui";
import { useRouter as useRouter11, useTranslation as useTranslation6 } from "@wbk/config";
import { formatDate as formatDate3 } from "@wbk/utils";

// src/components/calendar/monthly/DayCalendarBody.tsx
import { Carousel as Carousel13 } from "@wbk/ui";
import { endOfDay, endOfMonth, startOfDay, startOfMonth } from "@wbk/utils";
import { useRouter as useRouter10 } from "@wbk/config";
import { jsx as jsx24 } from "react/jsx-runtime";
var DayCalendarBody = ({ events: propEvents, date }) => {
  const { locale } = useRouter10();
  const { getItinerary, id } = useItinerary();
  const itinerary = getItinerary(id);
  const { data, isLoading } = useGetEventsList(
    {
      lang: locale,
      where: {
        AND: [
          {
            OR: [
              {
                schedule: {
                  openDateTime_lte: endOfDay(new Date(date)),
                  closeDateTime_gte: startOfDay(new Date(date))
                }
              },
              {
                schedule: {
                  openDateTime_gte: startOfDay(new Date(date)),
                  openDateTime_lte: endOfDay(new Date(date))
                }
              }
            ]
          },
          {
            schedule: {
              openDateTime_gte: startOfMonth(new Date(date)),
              openDateTime_lte: endOfMonth(new Date(date))
            }
          }
        ]
      }
    },
    {
      enabled: !itinerary
    }
  );
  const fetchedEvents = (data == null ? void 0 : data.items) || [];
  const displayEvents = itinerary ? propEvents || [] : fetchedEvents;
  if (isLoading) {
    return /* @__PURE__ */ jsx24("div", { className: "overflow-hidden", children: /* @__PURE__ */ jsx24(EventLoading_default, { count: 4, type: "carousel" }) });
  }
  return /* @__PURE__ */ jsx24(Carousel13, { className: "py-0.5", arrows: "middle", options: { dragFree: true }, children: displayEvents.map((event, i) => /* @__PURE__ */ jsx24("div", { className: "relative shrink-0 basis-80 md:basis-96 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx24(Item_default, { event }) }, i)) });
};
var DayCalendarBody_default = DayCalendarBody;

// src/components/calendar/monthly/DayCalendarRender.tsx
import { useMemo as useMemo5, useState as useState4 } from "react";
import { motion } from "motion/react";
import { useTranslation as useTranslation5 } from "@wbk/config";
import { Button as Button8, Typography as Typography14 } from "@wbk/ui";
import { useDeviceDetect } from "@wbk/hooks";
import { jsx as jsx25, jsxs as jsxs20 } from "react/jsx-runtime";
var DayCalendarRender = ({ open, events }) => {
  const { t } = useTranslation5("calendar_common");
  const { isDesktop } = useDeviceDetect();
  const [hoveredEvent, setHoveredEvent] = useState4(null);
  const limit = 3;
  const list = useMemo5(() => events.slice(0, limit), [events, limit]);
  return /* @__PURE__ */ jsxs20("div", { className: "grid grid-cols-2 gap-1 hover:opacity-70 sm:flex sm:flex-col sm:gap-2 lg:pt-12", children: [
    /* @__PURE__ */ jsx25(Button8, { onClick: open, className: "absolute inset-0", theme: "transparent" }),
    list.map((event) => /* @__PURE__ */ jsx25(
      ThemePopover_default,
      {
        open: isDesktop && (hoveredEvent == null ? void 0 : hoveredEvent.id) === event.id,
        onOpenChange: (isOpen) => isDesktop && setHoveredEvent(isOpen ? event : null),
        side: "top",
        sideOffset: 8,
        align: "center",
        content: /* @__PURE__ */ jsx25(ListItem_default, { event }),
        className: "w-full max-w-sm [&>div]:p-0",
        children: /* @__PURE__ */ jsx25(
          motion.div,
          {
            onHoverStart: () => isDesktop && setHoveredEvent(event),
            onHoverEnd: () => isDesktop && setHoveredEvent(null),
            className: "rounded-M relative block overflow-hidden",
            children: /* @__PURE__ */ jsxs20(
              Button8,
              {
                onClick: open,
                className: "rounded-M sm:bg-body-level-1 flex w-full shrink-0 justify-start gap-2 overflow-hidden p-0 sm:p-1",
                shape: "text",
                theme: "transparent",
                children: [
                  /* @__PURE__ */ jsx25(
                    ContentfulMedia_default,
                    {
                      media: event.image11,
                      width: 32,
                      height: 32,
                      fit: "thumb",
                      ratio: "1x1",
                      placeholder: true,
                      className: "aspect-1 rounded-radius object-cover"
                    }
                  ),
                  /* @__PURE__ */ jsx25(Typography14, { variant: "body-XS", className: "line-clamp-1 text-start", children: event.title })
                ]
              }
            )
          }
        )
      },
      event.id
    )),
    events.length > limit && /* @__PURE__ */ jsxs20(
      Button8,
      {
        onClick: open,
        className: "rounded-XL sm:bg-body-level-1 flex w-full shrink-0 justify-center gap-2 overflow-hidden p-0 sm:p-1",
        shape: "text",
        theme: "transparent",
        children: [
          /* @__PURE__ */ jsxs20(Typography14, { variant: "label-XS", strong: true, className: "text-body-dark hidden sm:block", children: [
            "+",
            events.length - limit,
            " ",
            t("calendar_common:event_calendar.others")
          ] }),
          /* @__PURE__ */ jsxs20(Typography14, { variant: "label-XXS", className: "text-body-light shrink-0 sm:hidden", children: [
            events.length - limit,
            " +"
          ] })
        ]
      }
    )
  ] });
};
var DayCalendarRender_default = DayCalendarRender;

// src/components/calendar/monthly/DayCalendarEvents.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var DayCalendarEvents = ({ events, date }) => {
  const { t } = useTranslation6("calendar_common");
  const { locale } = useRouter11();
  return /* @__PURE__ */ jsx26(
    ResponsiveModal,
    {
      size: "7xl",
      bodyClassName: "bg-body-level-1",
      className: "[&>div:nth-child(1)]:!bg-body-level-1 [&>div>div:nth-child(2)]:!bg-body-level-1",
      title: t("calendar_common:event_calendar.day_modal_title", {
        day: date.getDate(),
        month: formatDate3(date, locale, { month: "long" }),
        year: date.getFullYear()
      }),
      cancel: false,
      action: false,
      render: ({ open }) => /* @__PURE__ */ jsx26(DayCalendarRender_default, { open, events }),
      body: () => /* @__PURE__ */ jsx26(DayCalendarBody_default, { date, events })
    }
  );
};
var DayCalendarEvents_default = DayCalendarEvents;

// src/components/calendar/monthly/Grid.tsx
import { Fragment as Fragment4, jsx as jsx27, jsxs as jsxs21 } from "react/jsx-runtime";
var MonthlyGridCalendar = ({ events, isLoading, className }) => {
  const { locale } = useRouter12();
  const { monthIndex, year } = useCalendarQuery_default();
  if (isLoading)
    return /* @__PURE__ */ jsx27(MonthlyPlaceholder_default, {});
  return /* @__PURE__ */ jsx27("div", { className, children: /* @__PURE__ */ jsx27(
    DayPicker,
    {
      lang: locale,
      month: new Date(year, monthIndex),
      components: {
        Caption: () => /* @__PURE__ */ jsx27(Fragment4, {}),
        Day: ({ date }) => {
          const day = splitDateTime(date, "en", { month: "2-digit" });
          const { first = [], last = [] } = events[day.date] || {};
          const dayEvents = first.concat(last);
          const isWeekend = date.getDay() === 5 || date.getDay() === 6;
          if (dayEvents == null ? void 0 : dayEvents.length) {
            return /* @__PURE__ */ jsx27("div", { className: "h-full p-0 lg:p-1", children: /* @__PURE__ */ jsxs21(
              "div",
              {
                className: twMerge11(
                  "bg-secondary space-y-XXS lg:rounded-L border-paper relative h-full border p-1 md:p-2 lg:border-none",
                  isWeekend && "text-tertiary"
                ),
                children: [
                  /* @__PURE__ */ jsx27(
                    RoundedElement_default,
                    {
                      variants: ["top-left", "right-bottom"],
                      containerClassName: "hidden lg:block top-0 pe-XS pb-XS ltr:left-0 rtl:right-0",
                      children: /* @__PURE__ */ jsx27("div", { className: "bg-secondary rounded-L px-XS py-XS top-0", children: /* @__PURE__ */ jsx27(Typography15, { variant: "label-XS", strong: true, className: "text-start", children: new Date(date).toLocaleDateString(locale, {
                        day: "2-digit",
                        month: "short"
                      }) }) })
                    }
                  ),
                  /* @__PURE__ */ jsx27(Typography15, { variant: "label-XS", strong: true, className: "text-start lg:hidden", children: day.day }),
                  /* @__PURE__ */ jsx27(DayCalendarEvents_default, { events: dayEvents, date })
                ]
              }
            ) });
          }
          return /* @__PURE__ */ jsx27("div", { className: "h-full p-0 lg:p-1", children: /* @__PURE__ */ jsxs21(
            "div",
            {
              className: twMerge11(
                "bg-secondary space-y-XS lg:rounded-L relative h-full border p-1 md:p-2 lg:border-none",
                isWeekend && "text-tertiary"
              ),
              children: [
                /* @__PURE__ */ jsx27(
                  RoundedElement_default,
                  {
                    variants: ["top-left", "right-bottom"],
                    containerClassName: "hidden lg:block top-0 pe-XS pb-XS ltr:left-0 rtl:right-0",
                    children: /* @__PURE__ */ jsx27("div", { className: "bg-secondary rounded-L px-S py-XS top-0", children: /* @__PURE__ */ jsx27(Typography15, { variant: "label-XS", strong: true, className: "text-start", children: new Date(date).toLocaleDateString(locale, {
                      day: "2-digit",
                      month: "short"
                    }) }) })
                  }
                ),
                /* @__PURE__ */ jsx27("div", { className: "flex h-full flex-col items-center justify-center space-y-1 py-24", children: /* @__PURE__ */ jsx27(WaveIcon, { className: "h-2.5 w-5 shrink-0" }) })
              ]
            }
          ) });
        }
      }
    }
  ) });
};
var Grid_default = MonthlyGridCalendar;

// src/components/calendar/monthly/List.tsx
import { useMemo as useMemo6, useState as useState5 } from "react";
import { Button as Button9, Carousel as Carousel14, Typography as Typography16 } from "@wbk/ui";
import { formatDate as formatDate4, isSameDay, scrollIntoElementId, splitDateTime as splitDateTime2 } from "@wbk/utils";
import { DoubleArrowIcon } from "@wbk/svg";
import { useRouter as useRouter13, useTranslation as useTranslation7 } from "@wbk/config";

// src/components/ui/Loading/MonthlyListPlaceholder.tsx
import { jsx as jsx28, jsxs as jsxs22 } from "react/jsx-runtime";
var MonthlyListPlaceholder = ({ showDays = true }) => {
  return /* @__PURE__ */ jsxs22("div", { children: [
    showDays && /* @__PURE__ */ jsx28("div", { className: "container-1/2 flex gap-2 overflow-hidden md:container", children: Array.from({ length: 7 }, (_, i) => {
      return /* @__PURE__ */ jsx28(
        "div",
        {
          className: "bg-body-level-2 h-[120px] w-20 shrink-0 animate-pulse rounded-full"
        },
        i
      );
    }) }),
    /* @__PURE__ */ jsx28("div", { className: "container-1/2 space-y-4 py-10", children: Array.from({ length: 4 }, (_, i) => {
      return /* @__PURE__ */ jsxs22(
        "div",
        {
          className: "border-paper flex h-[300px] flex-col gap-5 border-b pb-6 last:border-none md:flex-row",
          children: [
            /* @__PURE__ */ jsx28("div", { className: "bg-body-level-2 h-16 w-40 animate-pulse rounded-md md:h-full" }),
            /* @__PURE__ */ jsx28("div", { className: "bg-body-level-2 h-full w-full animate-pulse rounded-md" })
          ]
        },
        i
      );
    }) })
  ] });
};
var MonthlyListPlaceholder_default = MonthlyListPlaceholder;

// src/components/calendar/monthly/List.tsx
import { Fragment as Fragment5, jsx as jsx29, jsxs as jsxs23 } from "react/jsx-runtime";
var MonthlyListCalendar = ({ events, isLoading }) => {
  const { t } = useTranslation7("calendar_common");
  const [openPast, setOpenPast] = useState5(false);
  const { locale } = useRouter13();
  const { days } = useCalendarQuery_default();
  const allEvents = useMemo6(() => {
    const initialIndex = days.findIndex(({ date }) => isSameDay(/* @__PURE__ */ new Date(), date));
    return {
      initialIndex,
      past: Object.entries(events.past),
      upcoming: Object.entries(events.upcoming)
    };
  }, [days, events.past, events.upcoming]);
  if (isLoading)
    return /* @__PURE__ */ jsx29(MonthlyListPlaceholder_default, {});
  return /* @__PURE__ */ jsxs23(Fragment5, { children: [
    /* @__PURE__ */ jsx29(
      Carousel14,
      {
        rootClassName: "container-1/2",
        options: { slidesToScroll: 1, startIndex: allEvents.initialIndex, dragFree: true },
        children: days.map(({ day, date, dayKey }) => {
          const { first = [], last = [] } = events.all[dayKey] || {};
          const hasEvents = first.length > 0 || last.length > 0;
          const isPast = /* @__PURE__ */ new Date() > date;
          const disabled = !hasEvents || isPast && !openPast || isPast && openPast && !hasEvents;
          return /* @__PURE__ */ jsx29(
            Button9,
            {
              theme: "secondary",
              className: "border-paper shrink-0 basis-20 rounded-full border py-8 text-center disabled:pointer-events-none disabled:select-none md:basis-24 ltr:mr-2 rtl:ml-2",
              disabled,
              onClick: () => scrollIntoElementId(dayKey),
              children: /* @__PURE__ */ jsxs23("div", { className: "flex flex-col gap-1", children: [
                /* @__PURE__ */ jsx29(Typography16, { variant: "heading-XXS", children: formatDate4(date, locale, { weekday: "short" }) }),
                /* @__PURE__ */ jsx29(Typography16, { variant: "heading-S", children: formatDate4(date, locale, { day: "2-digit" }) })
              ] })
            },
            day
          );
        })
      }
    ),
    !openPast && allEvents.past.length > 0 && /* @__PURE__ */ jsx29("div", { className: "container flex justify-center pt-10", children: /* @__PURE__ */ jsxs23(
      Button9,
      {
        shape: "text",
        className: "border-paper text-text rounded-none border-y",
        onClick: () => setOpenPast(true),
        children: [
          t("calendar_common:event_calendar.browse_previous_events_this_month"),
          /* @__PURE__ */ jsx29(DoubleArrowIcon, { className: "mx-1" })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs23("div", { className: "container-1/2", children: [
      openPast ? days.map((date) => {
        var _a, _b;
        const key = date.dayKey;
        const splitdate = splitDateTime2(key, locale, { month: "long", day: "2-digit" });
        const first = ((_a = events.past[key]) == null ? void 0 : _a.first) || [];
        const last = ((_b = events.past[key]) == null ? void 0 : _b.last) || [];
        const dayEvents = first.concat(last);
        if (!dayEvents.length)
          return null;
        return /* @__PURE__ */ jsxs23(
          "div",
          {
            id: key,
            className: "border-paper flex scroll-mt-44 flex-col gap-4 border-b py-10 last:border-none md:flex-row",
            children: [
              /* @__PURE__ */ jsxs23("div", { className: "bg-secondary rounded-L p-M me-4 flex w-auto min-w-44 items-center justify-between md:flex-col md:items-center md:justify-center md:gap-8", children: [
                /* @__PURE__ */ jsxs23("div", { className: "gap-XS flex md:flex-col", children: [
                  /* @__PURE__ */ jsx29(Typography16, { variant: "heading-L", className: "text-center", children: splitdate.day }),
                  /* @__PURE__ */ jsx29(Typography16, { variant: "heading-L", className: "text-center", children: splitdate.month })
                ] }),
                /* @__PURE__ */ jsx29(
                  Typography16,
                  {
                    className: "bg-body-level-2 rounded-XL py-XS px-S h-fit",
                    strong: true,
                    color: "tertiary",
                    children: t("calendar_common:events.events_total", { count: dayEvents.length })
                  }
                )
              ] }),
              /* @__PURE__ */ jsx29(Carousel14, { rootClassName: "w-full overflow-hidden", arrows: "middle", children: dayEvents.map((event) => /* @__PURE__ */ jsx29(
                "div",
                {
                  className: "relative shrink-0 basis-80 md:basis-[456px] ltr:mr-4 rtl:ml-4",
                  children: /* @__PURE__ */ jsx29(Item_default, { event })
                },
                event.id
              )) })
            ]
          },
          key
        );
      }) : null,
      allEvents.upcoming.length > 0 ? days.map((date) => {
        var _a, _b;
        const key = date.dayKey;
        const splitdate = splitDateTime2(key, locale, { month: "long", day: "2-digit" });
        const today = /* @__PURE__ */ new Date();
        const isToday = isSameDay(today, date.date);
        const first = ((_a = events.upcoming[key]) == null ? void 0 : _a.first) || [];
        const last = ((_b = events.upcoming[key]) == null ? void 0 : _b.last) || [];
        const dayEvents = first.concat(last);
        if (!dayEvents.length)
          return null;
        return /* @__PURE__ */ jsxs23(
          "div",
          {
            id: key,
            className: "border-paper flex scroll-mt-44 flex-col gap-4 border-b py-10 last:border-none md:flex-row",
            children: [
              /* @__PURE__ */ jsxs23("div", { className: "bg-secondary rounded-L p-M me-4 flex w-auto min-w-44 items-center justify-between md:flex-col md:items-center md:justify-center md:gap-8", children: [
                /* @__PURE__ */ jsxs23("div", { className: "flex gap-1 md:flex-col", children: [
                  /* @__PURE__ */ jsx29(Typography16, { variant: "heading-L", children: isToday ? t("calendar_common:date.today") : splitdate.day }),
                  !isToday && /* @__PURE__ */ jsx29(Typography16, { variant: "heading-L", children: splitdate.month })
                ] }),
                /* @__PURE__ */ jsx29(
                  Typography16,
                  {
                    className: "bg-body-level-2 rounded-XL py-XS px-S h-fit",
                    strong: true,
                    color: "tertiary",
                    children: t("calendar_common:events.events_total", { count: dayEvents.length })
                  }
                )
              ] }),
              /* @__PURE__ */ jsx29(
                Carousel14,
                {
                  rootClassName: "w-full text-center overflow-hidden",
                  className: "py-0.5",
                  arrows: "middle",
                  children: dayEvents.map((event) => /* @__PURE__ */ jsx29(
                    "div",
                    {
                      className: "relative shrink-0 basis-80 md:basis-[456px] ltr:mr-4 rtl:ml-4",
                      children: /* @__PURE__ */ jsx29(Item_default, { event })
                    },
                    event.id
                  ))
                }
              )
            ]
          },
          key
        );
      }) : null
    ] }),
    !allEvents.upcoming.length && /* @__PURE__ */ jsxs23("div", { className: "container space-y-2 py-40 text-center", children: [
      /* @__PURE__ */ jsx29(Typography16, { variant: "heading-L", as: "h4", children: t("calendar_common:event_calendar.there_are_no_events") }),
      /* @__PURE__ */ jsx29(Typography16, { color: "text-secondary", children: t("calendar_common:event_calendar.no_events_available_for_this_month") })
    ] })
  ] });
};
var List_default = MonthlyListCalendar;

// src/components/calendar/monthly/index.tsx
import { jsx as jsx30 } from "react/jsx-runtime";
var MonthlyCalendar = ({ displayAs }) => {
  const { locale } = useRouter14();
  const { year, monthIndex } = useCalendarQuery_default();
  const firstDayOfMonth = new Date(year, monthIndex, 1);
  const lastDayOfMonth = new Date(year, monthIndex + 1, 0);
  const start = new Date(firstDayOfMonth);
  start.setDate(start.getDate() - 7);
  const end = new Date(lastDayOfMonth);
  end.setDate(end.getDate() + 7);
  const { query } = useFilterQuery_default();
  const { data, isLoading } = useGetEventsList({
    lang: locale,
    where: {
      OR: [__spreadValues({}, query.where), { schedule: { openDateTime_gte: start, openDateTime_lte: end } }]
    }
  });
  const events = useMemo7(() => {
    const all = {};
    const past = {};
    const upcoming = {};
    const start2 = startOfDay2(/* @__PURE__ */ new Date());
    for (const event of (data == null ? void 0 : data.items) || []) {
      if (!event.schedule.openDateTime || !event.schedule.closeDateTime)
        continue;
      const startDate = new Date(event.schedule.openDateTime);
      const endDate = new Date(event.schedule.closeDateTime);
      const { day } = breakdownDurationToUnits({ from: startDate, to: endDate, units: ["day"] });
      const safeDay = day || 0;
      for (let i = 0; i <= safeDay; i++) {
        const today = dateAdd({ date: startDate, interval: "day", value: i });
        if (!today)
          return;
        const dayKey = splitDateTime3(today, "en", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }).date;
        const isPast = today < start2;
        const category = isPast ? past : upcoming;
        if (!category)
          continue;
        if (!category[dayKey])
          category[dayKey] = { first: [], last: [] };
        if (i === 0) {
          category[dayKey].first.push(event);
        } else {
          category[dayKey].last.push(event);
        }
        if (!all[dayKey])
          all[dayKey] = { first: [], last: [] };
        if (i === 0) {
          all[dayKey].first.push(event);
        } else {
          all[dayKey].last.push(event);
        }
      }
    }
    return { all, past, upcoming };
  }, [data == null ? void 0 : data.items]);
  if (!events)
    return null;
  return displayAs === "grid" ? /* @__PURE__ */ jsx30(Grid_default, { events: events.all, isLoading, className: "container" }) : /* @__PURE__ */ jsx30(List_default, { events, isLoading });
};
var monthly_default = MonthlyCalendar;

// src/components/calendar/CalendarSection.tsx
import { jsx as jsx31, jsxs as jsxs24 } from "react/jsx-runtime";
var CalendarSection = ({ section }) => {
  const { locale } = useRouter15();
  const { t } = useTranslation8("calendar_common");
  const { monthIndex, year, months, selectMonth } = useCalendarQuery_default();
  const monthName = formatDate5(new Date(year, monthIndex), locale, { month: "long" });
  return /* @__PURE__ */ jsxs24(DecoratedSection_default, { section, "data-testid": `section_current_calendar_${section.id}`, children: [
    /* @__PURE__ */ jsxs24("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx31(Typography17, { as: "h2", variant: "heading-XXL", children: t("calendar_common:current_calendar_title", { month: monthName }) }),
      /* @__PURE__ */ jsx31(
        ThemeMenu_default,
        {
          className: "inline-flex",
          render: ({ open }) => /* @__PURE__ */ jsxs24(Button10, { shape: "text", className: "p-0", onClick: open, children: [
            /* @__PURE__ */ jsx31(Typography17, { as: "h2", variant: "heading-XXL", className: "text-tertiary", children: monthName }),
            /* @__PURE__ */ jsx31("div", { className: "border-primary mx-2 rounded-full border p-2", children: /* @__PURE__ */ jsx31(ChevronIcon2, { className: "h-3 w-3 shrink-0 rotate-90" }) })
          ] }),
          trigger: { theme: "primary" },
          item: { theme: "primary" },
          value: monthIndex.toString(),
          options: Object.keys(months).map((mo) => {
            const monthIndex2 = months[mo];
            const monthName2 = formatDate5(new Date(year, monthIndex2), locale, { month: "long" });
            return {
              value: mo,
              text: /* @__PURE__ */ jsx31(Typography17, { variant: "heading-XS", children: monthName2 })
            };
          }),
          onChange: (e) => selectMonth(e.value)
        }
      )
    ] }),
    /* @__PURE__ */ jsx31(monthly_default, { displayAs: "grid" })
  ] });
};
var CalendarSection_default = CalendarSection;

// src/components/section/HeroSection.tsx
import { Typography as Typography18 } from "@wbk/ui";
import { jsx as jsx32, jsxs as jsxs25 } from "react/jsx-runtime";
var HeroSection = ({ section }) => {
  var _a, _b, _c;
  const card = (_a = section.contentCollection.items) == null ? void 0 : _a[0];
  const title = card.title || "";
  const title2 = (_b = card.titleLine2) == null ? void 0 : _b.slice(0, title.length - 3);
  const subtitle2 = card.subtitleLine2 || "";
  const subtitle = (_c = card.subtitle) == null ? void 0 : _c.slice(0, subtitle2.length - 3);
  const button = card.button;
  const description = card.description;
  if (!card)
    return null;
  return /* @__PURE__ */ jsxs25(
    DecoratedSection_default,
    {
      section: __spreadProps(__spreadValues({}, section), { linksCollection: { items: [] } }),
      "data-testid": `hero-section-${section.id}`,
      children: [
        /* @__PURE__ */ jsxs25("div", { className: "rounded-XL relative", children: [
          card.image11 && /* @__PURE__ */ jsx32(
            ContentfulMedia_default,
            {
              media: card.image11,
              className: "rounded-XL aspect-1 h-full object-cover sm:hidden"
            }
          ),
          card.image31 && /* @__PURE__ */ jsx32(
            ContentfulMedia_default,
            {
              media: card.image31,
              className: "rounded-XL hidden aspect-[3/1] min-h-[600px] object-cover sm:block"
            }
          ),
          title && /* @__PURE__ */ jsxs25(
            "div",
            {
              "data-button": !!button,
              className: "group absolute top-0 w-full max-w-[85%] ltr:left-0 rtl:right-0",
              children: [
                /* @__PURE__ */ jsx32(
                  RoundedElement_default,
                  {
                    variants: ["top-left", "right-bottom"],
                    containerClassName: "top-0 pe-XS static",
                    children: /* @__PURE__ */ jsx32(
                      LineClamp_default,
                      {
                        variant: "display-XS",
                        className: "group-data-[button=true]:pe-S group-data-[button=false]:ps-S py-S line-clamp-1 text-start",
                        children: title
                      }
                    )
                  }
                ),
                title2 && /* @__PURE__ */ jsx32(
                  RoundedElement_default,
                  {
                    variants: ["top-left", "right-bottom"],
                    containerClassName: " pe-XS pb-XS static",
                    children: /* @__PURE__ */ jsx32(
                      LineClamp_default,
                      {
                        variant: "display-XS",
                        className: "group-data-[button=true]:pe-S group-data-[button=false]:ps-S py-S line-clamp-1 text-start",
                        children: title2
                      }
                    )
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsxs25("div", { className: "absolute bottom-0 w-full", children: [
            button && /* @__PURE__ */ jsx32(
              RoundedElement_default,
              {
                variants: subtitle ? ["right-top", "bottom-left"] : ["left-top", "bottom-right"],
                containerClassName: "bottom-0 ltr:right-0 rtl:left-0 data-[subtitle=false]:ps-XS data-[subtitle=true]:pe-XS data-[subtitle=true]:ltr:left-0 data-[subtitle=true]:rtl:right-0 pt-XS hidden md:block",
                "data-subtitle": !!subtitle,
                children: /* @__PURE__ */ jsx32("div", { className: "", children: /* @__PURE__ */ jsx32(ContentfulButton_default, { button }) })
              }
            ),
            subtitle && /* @__PURE__ */ jsxs25("div", { className: "group absolute bottom-0 flex w-full max-w-[80%] flex-col items-end ltr:right-0 rtl:left-0", children: [
              /* @__PURE__ */ jsx32(
                RoundedElement_default,
                {
                  variants: ["left-bottom", "bottom-right", "left-top"],
                  containerClassName: "static ps-XS pt-XS",
                  children: /* @__PURE__ */ jsx32(LineClamp_default, { variant: "display-XS", className: "ps-S py-S line-clamp-1", children: subtitle })
                }
              ),
              subtitle2 && /* @__PURE__ */ jsx32(RoundedElement_default, { variants: ["bottom-right"], containerClassName: "static ps-XS pt-XS", children: /* @__PURE__ */ jsx32(Typography18, { variant: "display-XS", className: "ps-S py-S line-clamp-1", children: subtitle2 }) })
            ] }),
            !subtitle && description && /* @__PURE__ */ jsx32("div", { "data-button": !!button, className: "p-L group absolute bottom-0 w-full max-w-[80%]", children: /* @__PURE__ */ jsx32(
              Typography18,
              {
                variant: "heading-S",
                className: "max-w-[240px] sm:max-w-sm",
                color: "secondary",
                children: description
              }
            ) })
          ] })
        ] }),
        button && /* @__PURE__ */ jsx32(ContentfulButton_default, { className: "w-full md:hidden", button })
      ]
    }
  );
};
var HeroSection_default = HeroSection;

// src/components/section/TopHeroSection.tsx
import { Fragment as Fragment6, useState as useState6 } from "react";
import { Carousel as Carousel15, Divider as Divider3, Typography as Typography19 } from "@wbk/ui";
import { motion as motion2 } from "motion/react";
import { jsx as jsx33, jsxs as jsxs26 } from "react/jsx-runtime";
var TopHeroSection = ({ section }) => {
  var _a;
  const title = section.title;
  const subtitle = section.subtitle;
  const links = section.linksCollection.items;
  const backgrounds = (_a = section.sectionBackgroundsCollection) == null ? void 0 : _a.items;
  const cards = section.contentCollection.items;
  const [currentCard, setCurrentCard] = useState6(backgrounds[0]);
  if (!backgrounds.length)
    return null;
  return /* @__PURE__ */ jsx33(
    "section",
    {
      "data-testid": `top-hero-section-${section.id}`,
      className: "rounded-XL container relative top-12 aspect-[3/1] h-full min-h-[min(calc(100svh-60px),800px)] lg:top-7",
      children: /* @__PURE__ */ jsxs26("div", { className: "rounded-XL relative h-full w-full overflow-hidden", children: [
        backgrounds && /* @__PURE__ */ jsx33(
          motion2.div,
          {
            className: "bg-transparent",
            initial: { opacity: 0.2 },
            animate: { opacity: 1 },
            transition: { duration: 0.5 },
            children: /* @__PURE__ */ jsx33(
              ContentfulMedia_default,
              {
                autoPlay: true,
                muted: true,
                loop: true,
                media: currentCard,
                className: "rounded-XL rounded-s-XXL aspect-[3/1] min-h-[800px] min-w-full object-cover"
              }
            )
          },
          currentCard.sys.id
        ),
        /* @__PURE__ */ jsx33(
          RoundedElement_default,
          {
            variants: ["top-left", "right-bottom"],
            containerClassName: "absolute top-0 ltr:left-0 rtl:right-0 w-fit pe-XS pb-XS",
            children: /* @__PURE__ */ jsx33("div", { className: "h-12 w-16 md:h-14 md:w-20 lg:h-16" })
          }
        ),
        /* @__PURE__ */ jsx33("div", { className: "container absolute left-0 top-0 flex h-full flex-col justify-center", children: /* @__PURE__ */ jsxs26("div", { className: "max-w-3xl space-y-10", children: [
          /* @__PURE__ */ jsxs26("div", { children: [
            /* @__PURE__ */ jsx33(Typography19, { as: "h1", variant: "display-M", color: "secondary", className: "line-clamp-4", children: title }),
            subtitle && /* @__PURE__ */ jsx33(Typography19, { variant: "body-L", color: "secondary", className: "line-clamp-4", children: subtitle })
          ] }),
          links && /* @__PURE__ */ jsx33("div", { className: "gap-M flex flex-wrap items-center", children: links.map((link) => /* @__PURE__ */ jsx33(ContentfulButton_default, { button: link }, link.id)) })
        ] }) }),
        /* @__PURE__ */ jsxs26("div", { className: "space-y-S absolute top-24 hidden flex-col items-end lg:flex ltr:right-5 rtl:left-5", children: [
          /* @__PURE__ */ jsx33(Weather_default, {}),
          /* @__PURE__ */ jsx33("div", { className: "rounded-S p-S bg-secondary/5 rounded-bl-XL w-fit space-y-2 backdrop-blur-xl", children: backgrounds.length > 1 && backgrounds.map((item) => /* @__PURE__ */ jsx33(
            ContentfulMedia_default,
            {
              media: item,
              className: "rounded-S rounded-bl-XL h-24 w-36 cursor-pointer object-cover transition-transform hover:scale-105",
              onClick: () => setCurrentCard(item)
            },
            item.sys.id
          )) })
        ] }),
        cards.length > 0 && /* @__PURE__ */ jsx33(
          RoundedElement_default,
          {
            variants: ["bottom-left", "right-top"],
            containerClassName: "absolute bottom-0 ltr:left-0 rtl:right-0 max-w-[80%] pe-XS pt-XS",
            className: "px-0",
            children: /* @__PURE__ */ jsx33("div", { className: "bg-secondary rounded-L px-S", children: /* @__PURE__ */ jsx33(
              Carousel15,
              {
                as: "ul",
                rootClassName: "w-full overflow-hidden",
                className: "py-2",
                options: { dragFree: true },
                children: cards.map((card, i) => {
                  return /* @__PURE__ */ jsxs26(Fragment6, { children: [
                    /* @__PURE__ */ jsx33("li", { className: "h-full shrink-0 basis-48 sm:basis-56 ltr:mr-2 rtl:ml-2", children: /* @__PURE__ */ jsx33(
                      IconItem_default,
                      {
                        className: "flex flex-col items-start rounded-none",
                        card
                      }
                    ) }),
                    i < cards.length - 1 && /* @__PURE__ */ jsx33("li", { className: "m-auto h-10", children: /* @__PURE__ */ jsx33(Divider3, { className: "bg-body-level-3 h-full w-px" }) })
                  ] }, card.id);
                })
              }
            ) })
          }
        )
      ] })
    }
  );
};
var TopHeroSection_default = TopHeroSection;

// src/components/section/ContentfulSection.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var ContentfulSection = ({ section }) => {
  var _a, _b, _c, _d, _e;
  switch (section.renderType) {
    case "hero-top":
      return /* @__PURE__ */ jsx34(TopHeroSection_default, { section });
    case "hero":
      return /* @__PURE__ */ jsx34(HeroSection_default, { section });
    case "calendar":
      return /* @__PURE__ */ jsx34(CalendarSection_default, { section });
    case "collapsable-text":
      return /* @__PURE__ */ jsx34(CollapsableTextSection_default, { section });
    case "events-schedule":
      return /* @__PURE__ */ jsx34(ScheduleCarousel_default, { section });
    case "events-category":
      return /* @__PURE__ */ jsx34(CategoryCarousel_default, { section });
    default:
      break;
  }
  if (!((_b = (_a = section.contentCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0])) {
    return null;
  }
  const type = (_e = (_d = (_c = section.contentCollection) == null ? void 0 : _c.items) == null ? void 0 : _d[0]) == null ? void 0 : _e.__typename;
  switch (type) {
    case "Event":
      return section.renderType === "numbered-carousel" ? /* @__PURE__ */ jsx34(NumberedCarousel_default, { section }) : /* @__PURE__ */ jsx34(EventCarousel_default, { section });
    case "Card":
      return section.renderType === "icons" ? /* @__PURE__ */ jsx34(Icons_default, { section }) : section.renderType === "rectangular" ? /* @__PURE__ */ jsx34(Rectangular_default, { section }) : section.renderType === "icons-rounded" ? /* @__PURE__ */ jsx34(RoundedIcons_default, { section }) : section.renderType === "square" ? /* @__PURE__ */ jsx34(Square_default, { section }) : /* @__PURE__ */ jsx34(Carousel_default, { section });
    case "Category":
      return section.renderType === "rectangular" ? /* @__PURE__ */ jsx34(Carousel_default2, { section }) : /* @__PURE__ */ jsx34(RoundedCarousel_default, { section });
    default:
      return null;
  }
};
var ContentfulSection_default = ContentfulSection;

export {
  Item_default,
  Link_default,
  EventCarousel_default,
  EventLoading_default,
  Grid_default,
  MonthlyListPlaceholder_default,
  monthly_default,
  ContentfulSection_default
};
//# sourceMappingURL=chunk-RS2KXSOA.mjs.map